module.exports = __webpack_public_path__ + "static/media/pay-1.b0737d0b.svg";